'use strict';

angular
	.module('swaggerUi', ['ng', 'swaggerUiTemplates'])
	.directive('swaggerUi', ['$injector', 'config', function ($injector, config) {

	    return {
	        restrict: 'A',
	        controller: 'swaggerUiController',
			templateUrl: config.clientAppSrcPath + 'app-swagger-ui/templates/operation.html',
	        scope: {
	            swaggerOperation: '=?',
	            // Swagger descriptor loading indicator (variables, optional)
	            loading: '=?',
	            // Display API explorer (boolean, optional, default = false)
	            apiExplorer: '=?',
	            // Error handler (function, optional)
	            errorHandler: '=?'
	        },
	        link: function (scope) {
				scope.appRoot = config.clientAppSrcPath;

	            // check parameters
	            if (scope.permalinks && $injector.has('$route')) {
	                var $route = $injector.get('$route');
	                if ($route.current && $route.current.$$route && $route.current.$$route.reloadOnSearch) {
	                    console.warn('AngularSwaggerUI: when using permalinks you should set reloadOnSearch=false in your route config to avoid UI being rebuilt multiple times');
	                }
	            }
	            if (!scope.trustedSources && !$injector.has('$sanitize')) {
	                console.warn('AngularSwaggerUI: you must use ngSanitize OR set trusted-sources=true as directive param if swagger descriptors are loaded from trusted sources');
	            }
	            if (scope.validatorUrl === undefined) {
	                scope.validatorUrl = 'http://online.swagger.io/validator';
	            }
	        }
	    };
	}])
	.controller('swaggerUiController', ['$scope','swaggerClient',
		function ($scope, swaggerClient) {
		    var swagger = $scope.swaggerOperation.swagger;
		    $scope.infos = $scope.swaggerOperation.infos;
		    $scope.op = $scope.swaggerOperation.operation;
		    $scope.form = $scope.swaggerOperation.form;
		    $scope.resources = $scope.swaggerOperation.resources;

		    // HACK : Default value for ResponseType
		    $scope.form[$scope.op.id] = {};
		    $scope.form[$scope.op.id].responseType = $scope.form.responseType;

		    // WARNING authentication is not implemented, please use 'api-explorer-transform' directive's param to customize API calls
		    function onError(error) {
		        $scope.loading = false;
		        if (typeof $scope.errorHandler === 'function') {
		            $scope.errorHandler(error.message, error.code);
		        } else {
		            console.error(error.code, 'AngularSwaggerUI: ' + error.message);
		        }
		    }

		    /**
			 * show all resource's operations as list or as expanded list
			 */
		    $scope.expand = function (resource, expandOperations) {
		        resource.open = true;
		        for (var i = 0, op = resource.operations, l = op.length; i < l; i++) {
		            op[i].open = expandOperations;
		        }
		    };

		    $scope.submitExplorer = function (operation) {
		        operation.loading = true;
		        swaggerClient
					.send(swagger, operation, $scope.form[operation.id])
					.then(function (result) {
					    operation.loading = false;
					    operation.explorerResult = result;
					});
		    };

		}
	]);